<template>
  <div :style="{width:'100%',height:'350px'}">
    <el-amap vid="amap" class="amap" :center="center" :zoom="zoom" :plugin="plugin" :lang="$i18n.locale">
      <el-amap-marker :position="center">
      </el-amap-marker>
    </el-amap>
  </div>
</template>
<style>
  .amap {
    height: 350px;
  }
</style>
<script>
export default {
  name: 'Map',
  props: ['longitude', 'latitude'],
  data(){
    return {
      center: [this.longitude, this.latitude],
      zoom: 15,
      plugin: [{
        'pName': 'ElasticMarker'
      }]
    }
  }
}
</script>